'use client';

import { ICartItem, IOrder, IProduct } from "@/types/types";
import { createContext, useContext } from "react";

type CartContextType = {
  cartItems: ICartItem[];
  totalItems: number;
  totalPrice: number;
  isCartOpen: boolean;
  isLoading: boolean;
  isInCart: (product: IProduct, variantId?: number) => boolean;
  toggleProduct: (product: IProduct) => void;
  toggleModal: () => void;
  addItem: (item: ICartItem) => void;
  removeItem: (variantId: number) => void;
  increaseItem: (variantId: number) => void;
  decreaseItem: (variantId: number) => void;
  clearCart: () => void;
  handleCheckout: () => Promise<void>;
  abortCheckout: () => void;
}

export const CartContext = createContext<CartContextType | undefined>(undefined);

export const useCart = (): CartContextType => {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};